import { useEffect, useState } from 'react';
import { rage, useObservable } from '~/rage';
import { VehicleType } from '~/shared';
import { useLayoutSelector } from '../../redux/hooks';
import {
	StyledProgress,
	StyledProgressItem,
	StyledProgressWrapper,
} from './VehicleCountStats.styled';

const VehicleCountStats = () => {
	const totalParkingSlots = useObservable(rage.player.getTotalParkingSlots());

	const [countStats, setCountStats] = useState<{ [key: string]: number }>({
		[VehicleType.CAR]: 0,
		[VehicleType.BIKE]: 0,
	});

	const vehicles = useLayoutSelector((state) => state.vehicleList.vehicles);

	useEffect(() => {
		const newCountStats = { ...countStats };
		Object.keys(newCountStats).forEach((key) => {
			newCountStats[key] = 0;
		});

		vehicles.forEach((entry) => {
			if (Object.hasOwn(newCountStats, entry.type)) {
				newCountStats[entry.type]++;
			}
		});
		setCountStats(newCountStats);
	}, [vehicles]);

	return (
		<StyledProgressWrapper>
			<StyledProgress>
				{Object.entries(countStats).map(([type, count], index) => {
					return (
						<StyledProgressItem
							key={`stat#${index}`}
							className={type}
							style={{ width: `${(count / totalParkingSlots) * 100}%` }}
						/>
					);
				})}
			</StyledProgress>
		</StyledProgressWrapper>
	);
};

export { VehicleCountStats };
